import React, { useState, useEffect } from "react";
import axios from "axios";
import qs from "qs";
import VirtualizedMultiSelect from "components/General/VirtualizedMultiSelect";

import { Line } from "react-chartjs-2";
import { API_BASE } from "utils/api";
import {
  Grid,
  Box,
  Container,
  CardContent,
  Card,
} from "@mui/material";

const formControl = {
  margin: 1,
  minWidth: 120,
  maxWidth: 200,
};
const DatePicker = {
  width: "80%",
  minWidth: 50,
  marginRight: "auto",
};

const DistrictSales = ({
  startDate,
  endDate,
  districtId,
  DistrictDefaultStore,
}) => {
  const [districtStores, setDistrictStores] = useState([]);
  const [transactions, setTransactions] = useState([]);
  const [districtSales, setDistrictSales] = useState([]);
  const [storeSales, setStoreSales] = useState([]);
  const [paymentMethod, setPaymentMethod] = useState([]);
  const [storePaymentMethod, setStorePaymentMethod] = useState([]);
  const [allStoresSelected, setAllStoresSelected] = useState(false);
  const [districtFlag, setDistrictFlag] = useState(true);

  const paymentTypes = [
    "Cash",
    "Debit",
    "Visa",
    "Master",
    "American Express",
    "Gift Card",
  ];

  const isAllStorePaymentSelected =
    paymentTypes.length > 0 &&
    storePaymentMethod.length === paymentTypes.length;
  const isAllDistrictStoresSelected =
    transactions.length > 0 && districtStores.length === transactions.length;
  const isAllPaymentSelected =
    paymentTypes.length > 0 && paymentMethod.length === paymentTypes.length;

  useEffect(() => {
    axios
      .get(`${API_BASE}/districtStores/`, {
        params: {
          districtId: districtId,
        },
        paramsSerializer: (params) => {
          return qs.stringify(params, { arrayFormat: "repeat" });
        },
      })
      .then((res) => {
        setTransactions(res.data);
      });
  }, [districtId]);

  useEffect(() => {
    axios
      .get(`${API_BASE}/districtSales/`, {
        params: {
          districtId: districtId,
          startDate: startDate,
          endDate: endDate,
          paymentType: paymentMethod,
        },
        paramsSerializer: (params) => {
          return qs.stringify(params, { arrayFormat: "repeat" });
        },
      })
      .then((res) => {
        setDistrictSales(res.data);
      });
  }, [startDate, endDate, districtId, paymentMethod]);

  useEffect(async () => {
    const result = await axios.get(`${API_BASE}/purchase/`, {
      params: {
        storeId: districtStores,
        startDate: startDate,
        endDate: endDate,
        paymentType: storePaymentMethod,
        allStores: allStoresSelected,
        districtFlag: districtFlag,
      },
      paramsSerializer: (params) => {
        return qs.stringify(params, { arrayFormat: "repeat" });
      },
    });
    setStoreSales(result.data);
  }, [districtStores, storePaymentMethod, startDate, endDate]);

  const handleDistrictStores = (event) => {
    const value = event.target.value;
    if (value[value.length - 1] === "all") {
      setDistrictStores(
        districtStores.length === transactions.length ? [] : transactions,
      );
      setAllStoresSelected(true);
      return;
    }
    setDistrictStores(value);
    setAllStoresSelected(false);
  };

  const handlePaymentType = (event) => {
    const value = event.target.value;
    if (value[value.length - 1] === "all") {
      setPaymentMethod(
        paymentMethod.length === paymentTypes.length ? [] : paymentTypes,
      );
      return;
    }
    setPaymentMethod(value);
  };

  const handleStorePaymentType = (event) => {
    const value = event.target.value;
    if (value[value.length - 1] === "all") {
      setStorePaymentMethod(
        storePaymentMethod.length === paymentTypes.length ? [] : paymentTypes,
      );
      return;
    }
    setStorePaymentMethod(value);
  };

  return (
    <Container maxWidth={false}>
      <Grid container spacing={1}>
        <Grid item md={12} xs={12}>
          <Box ml={3}>
            <Card sx={{ height: "100%" }}>
              <CardContent>
                <Box pt={1} pb={3}>
                  <VirtualizedMultiSelect
                    label="Payment type"
                    id="paymentType-mutiple-checkbox"
                    value={paymentMethod}
                    options={paymentTypes}
                    onChange={handlePaymentType}
                    minWidth={200}
                    paperWidth={200}
                    formControlSx={formControl}
                    showSelectAll
                    selectAllChecked={isAllPaymentSelected}
                    selectAllIndeterminate={
                      paymentMethod.length > 0 &&
                      paymentMethod.length < paymentTypes.length
                    }
                  />
                </Box>

                <Grid item md={12} xs={12}>
                  <Line
                    data={districtSales.sales}
                    options={{
                      title: {
                        display: true,
                        text: "DistrictSales",
                        fontSize: 16,
                      },
                      legend: {
                        display: true,
                        position: "top",
                      },
                    }}
                  />
                </Grid>
              </CardContent>
            </Card>
          </Box>
        </Grid>
      </Grid>
      <Box pt={3} pl={3}>
        <Grid item md={12} xs={12}>
          <Card>
            <CardContent>
              <Box pt={3} pl={3}>
                <Grid container spacing={1}>
                  <Grid item md={6} xs={6}>
                    <VirtualizedMultiSelect
                      label="District Stores"
                      id="districtstores-mutiple-checkbox"
                      value={districtStores}
                      options={transactions}
                      onChange={handleDistrictStores}
                      minWidth={200}
                      paperWidth={200}
                      formControlSx={formControl}
                      showSelectAll
                      selectAllChecked={isAllDistrictStoresSelected}
                    />
                  </Grid>

                  <Box pt={1} pb={3}>
                    <Grid item md={3} xs={3}>
                      <VirtualizedMultiSelect
                        label="Payment type"
                        id="paymentStores-mutiple-checkbox"
                        value={storePaymentMethod}
                        options={paymentTypes}
                        onChange={handleStorePaymentType}
                        minWidth={200}
                        paperWidth={200}
                        formControlSx={formControl}
                        showSelectAll
                        selectAllChecked={isAllStorePaymentSelected}
                      />
                    </Grid>
                  </Box>

                  <Grid item md={12} xs={12}>
                    <Box pt={2}>
                      <Line
                        data={storeSales}
                        options={{
                          title: {
                            display: true,
                            text: "District Store Sales",
                            fontSize: 16,
                          },
                          legend: {
                            display: true,
                            position: "top",
                          },
                        }}
                      />
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Box>
    </Container>
  );
};
export default DistrictSales;
